(function () {
  'use strict';

  angular.module('wsLrs.services').factory('AggregationUtils', ['$filter', '$sanitize', 'Dimensions', 'Utils', 'CardText', function ($filter, $sanitize, Dimensions, Utils, CardText) {
    var has = Utils.has.bind(Utils);
    var get = Utils.getIn.bind(Utils);
    var capitalizeEachWord = Utils.capitalizeEachWord.bind(Utils);
    var defaultCardTextTemplate = {
      "cardView": {
        'tags': ['dimension'],
        "dimension": "{{dimension}}"
      },
      "detailView": {
        'tags': ['dimension'],
        "dimension": "{{dimension}}"
      },
      "chart": {
        'tags': ['dimension'],
        "dimension": "{{dimension}}"
      }
    };
    function getDimensionArray(dimension) {
      if (!dimension) {
        return [];
      }
      if (dimension.splitColumns) {
        return splitCompoundDimension(dimension);
      } else {
        return [dimension];
      }
    }
    function splitCompoundDimension(dimension) {
      if (!dimension) {
        return [];
      }
      var caseSensitive = dimension.caseSensitive,
        displayId = dimension.displayId,
        statementProperty = dimension.statementProperty,
        reverseColumnOrder = dimension.reverseColumnOrder;
      var type = "STATEMENT_PROPERTY";
      var index = reverseColumnOrder ? [1, 0] : [0, 1];
      return [{
        caseSensitive: caseSensitive,
        displayId: displayId,
        type: type,
        statementProperty: statementProperty.split("+")[index[0]]
      }, {
        caseSensitive: caseSensitive,
        displayId: displayId,
        type: type,
        statementProperty: statementProperty.split("+")[index[1]]
      }];
    }
    var res = {
      getDimensionDisplay: function getDimensionDisplay(name, dimension, compactDates) {
        if (name && (name.label || name.value !== undefined && name.value !== null)) {
          name = dimension.displayId ? name.value : name.label || name.value;
        }
        compactDates = compactDates || false;
        name = $sanitize($filter('stripSafeAngleBrackets')(name));
        if (dimension.type === "TIME") {
          switch (dimension.timePeriod) {
            case "CUSTOM":
              return name.replace(/^\d+\|/, '');
            case "WEEK":
              return compactDates ? moment.utc(name, 'YYYY-WW').format("[w] M/D/YY") : moment.utc(name, 'YYYY-WW').format("[Week of] MMMM Do, YYYY");
            case "MONTH":
              return compactDates ? moment.utc(name, 'YYYY-MM').format("MMM YYYY") : moment.utc(name, 'YYYY-MM').format("MMMM YYYY");
            case "YEAR":
              return compactDates ? moment.utc(name, 'YYYY').format("YYYY") : moment.utc(name, 'YYYY').format("YYYY");
            default:
              return compactDates ? moment.utc(name, 'YYYY-DDD').format("M/D/YY") : moment.utc(name, 'YYYY-DDD').format("MMMM Do, YYYY");
          }
        }
        if (dimension.type === "STATEMENT_PROPERTY") {
          switch (dimension.statementProperty) {
            case 'actor.person.id':
            case 'actor.groups.id':
            case 'actors.person.id':
            case 'actors.groups.id':
              return name;
            case 'object.definition.type':
              return name;
            case 'object.id':
            case 'activity.id':
              if (dimension.displayId) {
                return name;
              }
              if (!_.isUndefined(name) && name.indexOf('http') === 0) {
                //remove trailing slash
                name = name.replace(/\/$/, "");
                return decodeURI(name.substr(name.lastIndexOf('/') + 1)).trim();
              }
              return name;
          }
          if (dimension.statementProperty.endsWith('durationCentiseconds') || dimension.valueType === 'duration') {
            return $filter('compactTime')(name);
          }
          if (dimension.statementProperty === 'result.score.scaled' || dimension.valueType === 'percentage') {
            var scaledPercent = parseFloat(name) * 100;
            return Math.round(scaledPercent * 100) / 100 + "%";
          }
        }
        return name;
      },
      // should always return a string or null
      // TODO: Clean up the usages of this function--the measure and measureConfig objects are identical
      getMeasureValueDisplay: function getMeasureValueDisplay(measure, measureConfig, stats) {
        var percentageValueDisplay = function percentageValueDisplay(v) {
          return "".concat((v * 100).toFixed(1), "%");
        };
        if (!measure || _.isUndefined(measure.value) || _.isNull(measure.value)) {
          return '--';
        }
        var valueProducer = measureConfig.valueProducer;
        var format = null;
        var aggregation = measureConfig.aggregation;
        var aggregationType = aggregation ? aggregation.type : "";

        // Return values as-is, no implied formatting, if format of "string" or "none" is given
        if (valueProducer.format && (valueProducer.format.toLowerCase() === "none" || valueProducer.format.toLowerCase() === "string")) {
          return '' + $sanitize(measure.value);
        }
        if (['COUNT', 'DISTINCT_COUNT'].includes(aggregationType)) {
          return '' + $sanitize(measure.value);
        }
        if (valueProducer && valueProducer.type) {
          var m = null;
          if (valueProducer.statementProperty && valueProducer.statementProperty.endsWith("durationCentiseconds")) {
            if (valueProducer.format && valueProducer.format !== "duration") {
              return moment.duration(measure.value * 10).format(valueProducer.format);
            } else {
              return (measure.value < 0 ? '-' : '') + $filter('compactTime')(measure.value, stats && stats.max < 1000);
            }
          }
          switch (valueProducer.statementProperty) {
            case 'result.score.scaled':
              // if aggregation.type not SET or LIST, convert scores to %-based score
              if (["SET", "LIST"].includes(aggregationType)) {
                return '' + $sanitize(measure.value);
              }
              return percentageValueDisplay(measure.value);
            case 'stored':
            case 'timestamp':
              if (valueProducer.type === "TIME_BETWEEN") {
                if (valueProducer.format) {
                  return moment.duration(measure.value).format(valueProducer.format);
                } else {
                  return moment.duration(measure.value).humanize();
                  // return $filter('compactTime')(measure.value / 10);
                }
              }
              if (["SET", "LIST"].includes(aggregationType)) {
                return '' + $sanitize(measure.value);
              }
              if (typeof measure.value !== 'string') {
                // A date of 0 is essentially null
                if (measure.value === 0) {
                  return "--";
                } else if (measure.value) {
                  // Round to ensure no decimal timestamps - which are invalid.
                  measure.value = Math.round(measure.value, 0);
                }
              }
              if (valueProducer.timeZone) {
                m = moment.tz(measure.value, valueProducer.timeZone);
              } else {
                m = moment.utc(measure.value);
              }
              format = valueProducer.format || 'LL';
              return m.isValid() ? m.format(format) : measure.value;
            default:
              break;
          }
          if (valueProducer.type === "TIME_IN_APP") {
            return moment.duration(measure.value).humanize();
          }
          if (valueProducer.type === "TIME") {
            format = valueProducer.format || 'LL';
            if (valueProducer.timeZone) {
              m = moment.tz(measure.value, valueProducer.timeZone);
            } else {
              m = moment.utc(measure.value);
            }
            return m.isValid() ? m.format(format) : measure.value;
          }
          if (valueProducer.valueType === "time") {
            if (typeof measure.value !== 'string') {
              if (measure.value === 0) {
                return "--";
              } else if (measure.value) {
                // Round to ensure no decimal timestamps - which are invalid.
                measure.value = Math.round(measure.value, 0);
              }
            }
            if (valueProducer.timeZone) {
              m = moment.tz(measure.value, valueProducer.timeZone);
            } else {
              m = moment.utc(measure.value);
            }
            format = valueProducer.format || 'LL';
            return m.isValid() ? m.format(format) : measure.value;
          }
          if (valueProducer.valueType === "duration" || valueProducer.format === "duration") {
            var durationCentiseconds = typeof measure.value === 'string' ? Utils.convertISO8601DurationToCentiseconds(measure.value) : measure.value;
            return (measure.value < 0 ? '-' : '') + $filter('compactTime')(durationCentiseconds, stats && stats.max < 1000);
          }
          if (valueProducer.valueType === "percentage") {
            return percentageValueDisplay(measure.value);
          }
          if (valueProducer.type === "TIME_BETWEEN") {
            // This value is returned to us as millis from TimeBetweenTwoActivityIdsValueProducer,
            // so convert to centiseconds
            return $filter('compactTime')(measure.value / 10);
          }
          if (measure.label) {
            //if this measure has a label use the label
            return '' + $sanitize(measure.label);
          }
          if (measureConfig && aggregationType === 'GROUP_PERCENT') {
            return percentageValueDisplay(measure.value);
          }
          if (typeof measure.value === "number") {
            // Show max of two decimal places
            var numStr = '' + Math.round(measure.value * 100) / 100;
            //place commas for thousands
            return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        }
        return '' + $sanitize(measure.value);
      },
      getDimensionInSentence: function getDimensionInSentence(dimension, isPlural) {
        if (!dimension || !dimension.type) {
          return "";
        }
        var d = dimension.type.replace('_', ' ').toLowerCase();
        switch (d) {
          case 'statement property':
            switch (dimension.statementProperty) {
              case "object.definition.type":
                d = 'activity type';
                break;
              case "actor.person.id":
              case "actors.person.id":
                d = 'person';
                break;
              case "actor.groups.id":
              case "actors.groups.id":
                d = 'group';
                break;
              case "object.id":
              case "activity.id":
                d = "activity";
                break;
              case "actors.person.id+object.id":
                d = 'person & activity';
                break;
              case "object.id+actors.person.id":
                d = 'activity & person';
                break;
              default:
                d = 'item';
            }
            break;
          case "time":
            d = dimension.timePeriod.toLowerCase();
            break;
          default:
            d = 'item';
            break;
        }
        if (isPlural) {
          d = $filter('pluralizeNoun')(d);
        }
        return d;
      },
      getDimensionLabeler: function getDimensionLabeler() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          config = _ref.config,
          _ref$cardTextTemplate = _ref.cardTextTemplate,
          cardTextTemplate = _ref$cardTextTemplate === void 0 ? defaultCardTextTemplate : _ref$cardTextTemplate,
          _ref$context = _ref.context,
          context = _ref$context === void 0 ? 'cardView' : _ref$context;
        var cardText = CardText.bind(cardTextTemplate, config);
        var getDimensionInSentence = this.getDimensionInSentence.bind(this);
        return function (dimension) {
          var name = capitalizeEachWord(getDimensionInSentence(dimension, false));
          var label = cardText.render("".concat(context, ".dimension"), {
            dimension: name
          });
          if (!has(config, "cardText.".concat(context, ".dimension")) && has(dimension, "displayName")) {
            label = get(dimension, "displayName");
          }
          return label;
        };
      },
      getDimensionLabels: function getDimensionLabels() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          config = _ref2.config,
          _ref2$cardTextTemplat = _ref2.cardTextTemplate,
          cardTextTemplate = _ref2$cardTextTemplat === void 0 ? defaultCardTextTemplate : _ref2$cardTextTemplat,
          _ref2$context = _ref2.context,
          context = _ref2$context === void 0 ? 'cardView' : _ref2$context;
        var getDimensionLabel = this.getDimensionLabeler({
          config: config,
          cardTextTemplate: cardTextTemplate,
          context: context
        });
        var dimensionLabels = config.dimensions.map(getDimensionLabel);
        return dimensionLabels;
      },
      isDurationBasedMeasure: function isDurationBasedMeasure(measure) {
        if (!measure || !measure.valueProducer) {
          return false;
        }
        var maybeStmtProp = Utils.getIn(measure, ['valueProducer', 'statementProperty'], {
          alt: ''
        });
        return maybeStmtProp.endsWith('durationCentiseconds') || _.contains(["TIME", "TIME_BETWEEN", "TIME_IN_APP"], measure.valueProducer.type) || measure.valueProducer.valueType === "duration";
      },
      isPercentageBasedMeasure: function isPercentageBasedMeasure(measure) {
        if (!measure || !measure.valueProducer) {
          return false;
        }
        return measure.valueProducer.valueType === 'percentage' || measure.valueProducer.statementProperty === 'result.score.scaled';
      },
      getMeasureMinValueOrDefault: function getMeasureMinValueOrDefault(measure, def) {
        var value = measure && measure.min && parseFloat(measure.min.value);
        if (_.isFinite(def) && _.isFinite(value)) {
          return Math.min(def, value);
        } else if (_.isFinite(value)) {
          return value;
        } else if (_.isFinite(def)) {
          return def;
        } else {
          return null;
        }
      },
      getMeasureMaxValueOrDefault: function getMeasureMaxValueOrDefault(measure, def) {
        var value = measure && measure.max && parseFloat(measure.max.value);
        if (_.isFinite(def) && _.isFinite(value)) {
          return Math.max(def, value);
        } else if (_.isFinite(value)) {
          return value;
        } else if (_.isFinite(def)) {
          return def;
        } else {
          return null;
        }
      },
      /**
       * @param configObj resembles:
       * {
       *     dimension        [string],
       *     measures         [array],
       *     [sortAscending]  [string],
       *     [sortDescending] [string],
       *     [sortDirections] [array],
       *     [defaultSort]    [string]
       * }
       * @returns
       * {
       *      options:        array,
       *      option:         string,
       *      index:          number,
       *      directions:     string[],
       *      direction:      string,
       *      defaultSort:    string,
       *      setOptions:     function,
       *      setSelections:  function,
       *      sortDirective:  function
       * }
       */
      sortConfig: function sortConfig(configObj) {
        var sortAscending = configObj.sortAscending || 'Ascending',
          sortDescending = configObj.sortDescending || 'Descending',
          sortDirections = configObj.sortDirections || [sortAscending, sortDescending],
          defaultSort = configObj.defaultSort || "-measure[0].value";
        var config = {
          options: null,
          // Array of sort options (some combination of dimension + measures)
          option: null,
          // Current selection from options
          index: null,
          // Index of current selection from options
          directions: sortDirections,
          // Array of sort direction options
          direction: null,
          // Current selection from directions
          defaultSort: defaultSort,
          hiddenMeasures: [],
          usingTwoDimensionsForSorting: false,
          // Builds options array from dimension & measures
          setOptions: function setOptions(dimensions, measures, hiddenMeasures) {
            dimensions = dimensions instanceof Array ? dimensions : [dimensions]; // Force to array
            var isCompoundDimension = Dimensions.isCompoundDimension({
              dimensions: dimensions.map(function (d) {
                return d && d.val;
              })
            });
            this.usingTwoDimensionsForSorting = isCompoundDimension;

            // Save current selection index
            if (this.option !== null) {
              this.index = this.options.indexOf(this.option);
            }
            if (isCompoundDimension && dimensions.length === 1) {
              this.options = Dimensions.separateCompoundDimension(dimensions[0].val).concat(measures);
            } else if (dimensions.length > 1) {
              this.options = dimensions.concat(measures);
            } else {
              var name = dimensions[0] && dimensions[0].name || 'Item';
              this.options = [{
                name: name
              }].concat(measures);
            }
            if (hiddenMeasures) {
              this.hiddenMeasures = hiddenMeasures;
            }

            // For initial page render, add in total before
            // setting option/index if the defaultSort was Total
            if (this.defaultSort.endsWith('sum')) {
              this.options.push({
                name: "-Total",
                value: 'sum'
              });
              this.index = this.options.length - 1;
            }

            // Select option from index value
            if (this.index !== null) {
              this.index = Math.min(this.index, this.options.length - 1);
              this.option = this.options[this.index];
            }
          },
          // Set the actively selected sorting options
          setSelections: function setSelections(sort) {
            var isCompoundDimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var parts = sort.split(/\[|]\./);
            var type = parts[0].replace('-', '');
            var index = sort.indexOf("sum") === -1 ? parseInt(parts[1], 10) : this.options.length - 1;
            // Is the index going to be a range for range charts?
            var isRange = parts.length > 1 && parts[1].indexOf('-') !== -1;
            var moveOptionIndexForMeasure = !isRange && type === 'measure';
            if (moveOptionIndexForMeasure) {
              index++;
              if (isCompoundDimension) {
                index++;
              }
            }

            /**
             * Long Explanation:
             * For ranges, the following formula describes the indices:
             * [ (2i - 1)  + '-' + (2i - 2) ]
             * ex. for index 1, you'd get: [1-0]
             *
             * Since `parseInt('[1-0]') === 1` (left-side formula) we'll just
             * use the left side of the formula in reverse: index = ( 1 + index ) / 2
             */
            if (isRange && type !== 'dimension') {
              index = (index + 1) / 2;
            }
            if (this.options) {
              this.index = Math.min(index, this.options.length - 1);
              this.option = this.options[this.index];
            } else {
              this.index = index; // save index to use when options is available
            }
            this.direction = sort.indexOf('-') === 0 ? sortDescending : sortAscending;

            // Currently, only for range charts. But check if the sort is absolute or not.
            if (sort.indexOf('|') > -1) {
              this.direction += ' (Absolute)';
            }
          },
          // Return sort directive for server-side paging and persisting of selected sort (defaultSort)
          sortDirective: function sortDirective(chartType) {
            if (this.options && this.option && this.direction) {
              var option = this.option;
              var optionIndex = _.findIndex(this.options, function (o) {
                return angular.equals(o, option);
              });
              var dir = this.direction.startsWith('Descending') ? '-' : '';
              var minimumDimensionIndex = this.usingTwoDimensionsForSorting ? 1 : 0;
              var type = optionIndex > minimumDimensionIndex ? 'measure' : 'dimension';

              // If we're using a range chart, we'll use some math to determine what our indices should be.
              // For range charts, the index is always '2i-1' - '2i-2' where i is the selected index of the sorting dropdown
              var index = optionIndex;
              if (chartType === 'range') {
                index = optionIndex > 0 ? 2 * optionIndex - 1 + '-' + (2 * optionIndex - 2) : 0;
              } else if (type === 'measure') {
                index = optionIndex - (minimumDimensionIndex + 1);
                _.each(this.hiddenMeasures, function (hiddenIdx) {
                  //for every hidden measure prior to your selection add one to the index to skip it
                  if (hiddenIdx <= index) {
                    index++;
                  }
                });
              }
              var field = type === 'dimension' ? 'label' : 'value';
              var sortDirective = type + '[' + index + '].' + field;
              if (chartType === 'range' && this.direction.endsWith('(Absolute)')) {
                sortDirective = '|' + sortDirective + '|';
              }
              if (chartType === 'bar' && this.option.value === 'sum') {
                sortDirective = 'sum';
              }
              return dir + sortDirective;
            }
            return defaultSort;
          }
        };
        if (configObj.dimension && configObj.measures) {
          config.setOptions(configObj.dimension, configObj.measures, configObj.hiddenMeasures);
        }
        return config;
      },
      migrateDefaultSort: function migrateDefaultSort(sortDirective) {
        if (!sortDirective || sortDirective.indexOf(':') === -1) {
          return sortDirective;
        }
        return sortDirective.replace("dim:", "dimension[").replace("agg:", "measure[").replace(":", "].");
      },
      hideMeasures: function hideMeasures(config) {
        return function (m, i) {
          return !config.hiddenMeasures || config.hiddenMeasures.indexOf(i - config.dimensions.length) === -1;
        };
      },
      // TODO: Deduplicate some of the unsortable boolean init
      hideNonSortableFilter: function hideNonSortableFilter(config) {
        return function (m) {
          var aggregationType = m.aggregation ? m.aggregation.type : "";
          var valueProducerType = m.valueProducer ? m.valueProducer.type : "";
          var sortableAggregationType = !_.contains(["FORMULA"], aggregationType);
          var sortableValueProducer = !_.contains(["MATCH_IN_ARRAY", "FLAT_GROUP_OF_TYPE", "GROUP_OF_TYPE", "GROUPS_OF_TYPE", "FORMULA"], valueProducerType);
          var sortableTimeBetween = !(valueProducerType === "TIME_BETWEEN" && Dimensions.isCompoundDimension(config));
          return sortableAggregationType || sortableValueProducer || sortableTimeBetween;
        };
      },
      nonSortableControls: function nonSortableControls(config) {
        return function (m) {
          var aggregationType = m.aggregation ? m.aggregation.type : "";
          var valueProducerType = m.valueProducer ? m.valueProducer.type : "";
          var nonSortableAggregationType = _.contains(["FORMULA"], aggregationType);
          var nonSortableValueProducer = _.contains(["MATCH_IN_ARRAY", "FLAT_GROUP_OF_TYPE", "GROUP_OF_TYPE", "GROUPS_OF_TYPE", "FORMULA"], valueProducerType);
          var nonSortableTimeBetween = valueProducerType === "TIME_BETWEEN" && Dimensions.isCompoundDimension(config);
          var nonSortableType = '';
          var nonSortableTypeName = '';
          if (nonSortableAggregationType) {
            nonSortableType = 'aggregation';
            nonSortableTypeName = aggregationType;
          } else if (nonSortableValueProducer || nonSortableTimeBetween) {
            nonSortableType = 'value producer';
            nonSortableTypeName = valueProducerType;
          }

          // may be helpful to add a reason later for something like the TIME_BETWEEN value producer when dimension in compound
          return {
            nonSortable: nonSortableAggregationType || nonSortableValueProducer || nonSortableTimeBetween,
            nonSortType: nonSortableType,
            nonSortTypeName: nonSortableTypeName
          };
        };
      },
      getDimensionArray: getDimensionArray
    };
    return res;
  }]);
})();
